export const validatePassword = (value) => {
  if (!value) return Promise.resolve();
  if (!/(?=.*[A-Z])/.test(value))
    return Promise.reject(new Error('Password must contain at least one uppercase letter.'));
  if (!/(?=.*[a-z])/.test(value))
    return Promise.reject(new Error('Password must contain at least one lowercase letter.'));
  if (!/(?=.*\d)/.test(value))
    return Promise.reject(new Error('Password must contain at least one number.'));
  if (!/(?=.*[!@#$%^&*])/.test(value))
    return Promise.reject(new Error('Password must contain at least one special character.'));
  if (!/^[A-Za-z\d!@#$%^&*]{12,}$/.test(value))
    return Promise.reject(new Error('Password must be at least 12 characters long.'));
  return Promise.resolve();
};

export const confirmValidatePassword = (value, previousPassword) => {
  if (!value) return Promise.resolve();
  if (!/(?=.*[A-Z])/.test(value))
    return Promise.reject(new Error('Password must contain at least one uppercase letter.'));
  if (!/(?=.*[a-z])/.test(value))
    return Promise.reject(new Error('Password must contain at least one lowercase letter.'));
  if (!/(?=.*\d)/.test(value))
    return Promise.reject(new Error('Password must contain at least one number.'));
  if (!/(?=.*[!@#$%^&*])/.test(value))
    return Promise.reject(new Error('Password must contain at least one special character.'));
  if (!/^[A-Za-z\d!@#$%^&*]{12,}$/.test(value))
    return Promise.reject(new Error('Password must be at least 12 characters long.'));
  if (previousPassword !== value) {
    return Promise.reject(new Error('Confirm Passwords do not match.'));
  }
  return Promise.resolve();
};

export const previousValidatePassword = (value, previousPassword) => {
  if (!value) return Promise.resolve();
  if (previousPassword !== value) {
    return Promise.reject(new Error('Confirm Passwords do not match.'));
  }
  return Promise.resolve();
};

export const validateMobile = (value) => {
  if (!value) return Promise.resolve();
  if (value && !/^[6-9]\d{9}$/g.test(value)) {
    return Promise.reject(new Error('Please enter a valid Mobile Number.'));
  }
  return Promise.resolve();
};
